import {Box, Button, Typography} from "@mui/material";
import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import Avatar from "@mui/material/Avatar";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {useMq} from "@buildwitt/shapeshift-common/v1/hooks";
import { useGetMe } from "@/app2/shared/data";

const useStyles = makeStyles()(() => ({
	root: {
		textAlign: "center",
		position: "relative",
		minHeight: 400,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden"
	},
	tagLine: {
		margin: "12px 0"
	},
	closeIcon: {
		position: "absolute",
		top: 12,
		right: 12,
		color: "#fff",
		cursor: "pointer"
	}
}));

interface IProps {
	onContinue: () => void;
	courseTitle?: string;
}

export const CompletionCelebrationContent: FC<IProps> = ({onContinue, courseTitle}) => {
	const {t} = useSSTranslation();
	const mq = useMq();
	const {classes} = useStyles();
	const {data: user} = useGetMe();
	const profileImage = user?.profileImage;

	return (
		<Box className={classes.root} sx={{height: mq.mobile ? "70vh" : undefined}}>
			<Box
				sx={{
					position: "relative",
					zIndex: 1,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					width: "100%",
					maxWidth: 400,
					mx: "auto",
					flex: 1
				}}
			>
				{profileImage && (
					<Avatar
						src={profileImage}
						sx={{width: 120, height: 120, margin: "16px auto"}}
					/>
				)}

				<Typography variant="h3" className={classes.tagLine} fontSize={34}>
					{t("completion_celebration_congratulations", "Congratulations!")}
				</Typography>

				<Typography variant="h6" className={classes.tagLine}>
					{t("completion_celebration_you_completed", "You completed")}{" "}
					<Box component="span" sx={{color: "orange"}}>
						{courseTitle}
					</Box>
				</Typography>

				<Box sx={{flexGrow: 1}} />

				<Button
					variant="contained"
					sx={{color: "#000000DE", fontWeight: "600", alignSelf: mq.mobile ? "stretch" : undefined, marginBottom: "40px"}}
					onClick={() => onContinue?.()}
				>
					{t("common_continue", "continue").toUpperCase()}
				</Button>
			</Box>
		</Box>
	);
};
